import { client } from "./graphql/client";
import { GET_ONE } from 'react-admin';
import { getCustomerCardSpendFeeQuery, getOnRampFiatBankWalletFeeQuery, getOnRampFiatCardFeeQuery, getOffRampFiatBankWalletFeeQuery, setCardSpendFxOverrideMutation, setOnRampFiatBankWalletFxOverrideMutation, setOnRampFiatCardFxOverrideMutation, setOffRampFiatBankWalletFxOverrideMutation } from "./graphql/fees/queries";

export const feesDataProvider = {
  async getOne(resource, params) {
    const { customerId } = params;
    const [cardRes, onRampRes, onRampCardRes, offRampRes] = await Promise.allSettled([
      client.query({ query: getCustomerCardSpendFeeQuery, variables: { customerId }, fetchPolicy: 'no-cache' }),
      client.query({ query: getOnRampFiatBankWalletFeeQuery, variables: { customerId }, fetchPolicy: 'no-cache' }),
      client.query({ query: getOnRampFiatCardFeeQuery, variables: { customerId }, fetchPolicy: 'no-cache' }),
      client.query({ query: getOffRampFiatBankWalletFeeQuery, variables: { customerId }, fetchPolicy: 'no-cache' }),
    ]);

    const safeData = (r) => (r?.status === 'fulfilled' ? r.value?.data : null);
    const safeError = (r) => (r?.status === 'rejected' ? (r.reason || true) : null);

    const cardData = safeData(cardRes);
    const onRampData = safeData(onRampRes);
    const onRampCardData = safeData(onRampCardRes);
    const offRampData = safeData(offRampRes);

    const feeCardSpend = cardData?.getCustomerCardSpendFee_Admin || null;
    const feeOnRampBankWallet = onRampData?.getOnRampFiatBankWalletFee_Admin || null;
    const feeOnRampCard = onRampCardData?.getOnRampFiatCardFee_Admin || null;
    const feeOffRampBankWallet = offRampData?.getOffRampFiatBankWalletFee_Admin || null;

    const errors = {
      cardSpend: safeError(cardRes),
      onRampBankWallet: safeError(onRampRes),
      onRampCard: safeError(onRampCardRes),
      offRampBankWallet: safeError(offRampRes),
    };

    return { data: { id: customerId, feeCardSpend, feeOnRampBankWallet, feeOnRampCard, feeOffRampBankWallet, errors } };
  },
};

export const updateFees = async (params) => {
  const { customerId, context, fx, createdBy } = params;
  switch (context) {
    case 'Card Spend Fee (Non-USD spending)':
      return client.mutate({ mutation: setCardSpendFxOverrideMutation, variables: { customerId, fx, createdBy } });
    case 'On-ramp Fee (Bank Transfer, Mobile Wallet)':
      return client.mutate({ mutation: setOnRampFiatBankWalletFxOverrideMutation, variables: { customerId, fx, createdBy } });
    case 'On-ramp Fee(Card)':
      return client.mutate({ mutation: setOnRampFiatCardFxOverrideMutation, variables: { customerId, fx, createdBy } });
    case 'Off-ramp Fee (Bank Transfer, Mobile Wallet)':
      return client.mutate({ mutation: setOffRampFiatBankWalletFxOverrideMutation, variables: { customerId, fx, createdBy } });
    default:
      throw new Error('Unknown fee context');
  }
}


